import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
    const initializeBlock = function() {
        var splideElements = document.querySelectorAll('.photo-gallery-section__bna__slider');

        if (splideElements.length > 0) {
            splideElements.forEach(function (splideElement) {
                // Destroy existing instance if already initialized
                if (splideElement.splide) {
                    splideElement.splide.destroy();
                }

                const counter = splideElement.querySelector('.slider-info .slider-numbers');
                const perPage = parseInt(splideElement.getAttribute('data-per-page')) || 1;
                const showArrows = splideElement.getAttribute('data-arrows') !== 'false';
                const slides = Array.from(splideElement.querySelectorAll('.splide__slide'));

                var splide = new Splide(splideElement, {
                    type: 'slider',
                    speed: 1000,
                    arrows: showArrows,
                    pagination: false,
                    rewind: false,
                    perPage: perPage,
                    perMove: 1,
                    focus: 0,
                    trimSpace: false,
                    gap: 40,
                    waitForTransition: false,
                    arrowPath: 'M8.354,0,0,8.353l8.354,8.354L9.06,16,1.915,8.853H16.707v-1H1.915L9.06.706Z',
                    breakpoints: {
                        768: {
                            perPage: 1,
                            gap: 12,
                        }
                    }
                });

                splide.mount();

                // Keep a reference for cleanup
                splideElement.splide = splide;

                const existingPagination = splideElement.parentElement.querySelector('.photo-gallery-section__pagination');
                if (existingPagination) {
                    existingPagination.remove();
                }

                const pagination = document.createElement('div');
                pagination.className = 'photo-gallery-section__pagination';

                slides.forEach(function (_, index) {
                    const button = document.createElement('button');
                    button.type = 'button';
                    button.className = 'photo-gallery-section__pagination__item';
                    button.setAttribute('aria-label', `Go to gallery slide ${index + 1}`);
                    button.addEventListener('click', function () {
                        splide.go(index);
                    });
                    pagination.appendChild(button);
                });

                splideElement.insertAdjacentElement('afterend', pagination);

                // Counter function
                function updateCounter(splide) {
                    if (counter) {
                        var currentSlide = splide.index + 1;
                        var totalSlides = splide.length;
                        counter.textContent = `${currentSlide}/${totalSlides}`;
                    }

                    const paginationItems = pagination.querySelectorAll('.photo-gallery-section__pagination__item');
                    paginationItems.forEach(function (item, index) {
                        item.classList.toggle('is-active', index === splide.index);
                        item.setAttribute('aria-current', index === splide.index ? 'true' : 'false');
                    });
                }

                updateCounter(splide);
                splide.on('move', function () {
                    updateCounter(splide);
                });
            });
        }
    }
    
    if (window.acf) {
        window.acf.addAction('render_block_preview/type=photo-gallery-section', initializeBlock);
    } else {
        initializeBlock();
    }
});
